/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import {
  GET_MODULES_FOR_CLIENT_ROLE_FAILURE,
  GET_MODULES_FOR_CLIENT_ROLE_REQUEST,
  GET_MODULES_FOR_CLIENT_ROLE_SUCCESS,
  GET_MODULES_FOR_CREATE_FAILURE,
  GET_MODULES_FOR_CREATE_REQUEST,
  GET_MODULES_FOR_CREATE_SUCCESS,
  GET_SUB_MODULES_FOR_CLIENT_ROLE_FAILURE,
  GET_SUB_MODULES_FOR_CLIENT_ROLE_REQUEST,
  GET_SUB_MODULES_FOR_CLIENT_ROLE_SUCCESS,
} from "./clientRolesTypes";

const initialStateForRoles = {
  loading: false,
  rolesData: [],
  error: "",
};

const getModuleRolesReducer = (state = initialStateForRoles, action) => {
  switch (action.type) {
    case GET_SUB_MODULES_FOR_CLIENT_ROLE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_SUB_MODULES_FOR_CLIENT_ROLE_SUCCESS:
      return {
        loading: false,
        rolesData: action.payload,
        error: "",
      };
      case GET_SUB_MODULES_FOR_CLIENT_ROLE_FAILURE:
        return {
          loading: false,
          rolesData: [],
          error: action.payload,
        };
        default:
          return state;
        }
      };

const initialStateForAdminRoles = {
  loading: false,
  rolesData: [],
  error: "",
};

const getAdminModuleRolesReducer = (state = initialStateForAdminRoles, action) => {
  switch (action.type) {
    case GET_MODULES_FOR_CLIENT_ROLE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_MODULES_FOR_CLIENT_ROLE_SUCCESS:
      return {
        loading: false,
        rolesData: action.payload,
        error: "",
      };
    case GET_MODULES_FOR_CLIENT_ROLE_FAILURE:
      return {
        loading: false,
        rolesData: [],
        error: action.payload,
      };
    default:
      return state;
  }
};
const initialStateForCreate = {
  loading: false,
  createRoles: [],
  error: "",
};

const getCreateRolesReducer = (state = initialStateForCreate, action) => {
  switch (action.type) {
    case GET_MODULES_FOR_CREATE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_MODULES_FOR_CREATE_SUCCESS:
      return {
        loading: false,
        createRoles: action.payload,
        error: "",
      };
    case GET_MODULES_FOR_CREATE_FAILURE:
      return {
        loading: false,
        createRoles: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export { getModuleRolesReducer,getAdminModuleRolesReducer ,getCreateRolesReducer};
